var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"id":"candidate-tag-modal","visible":_vm.innerVisible,"title":_vm.title,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event},"close":function($event){_vm.innerVisible = false}}},[_c('CandidateTags',{attrs:{"candidate":_vm.candidate,"bulk-selection-attributes":_vm.bulkSelectionAttributes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }